import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import FormatCurrency from "../../utils/FormatCurrency";
import { Button, Stack, Typography } from "@mui/material";

import ImageIcon from "@mui/icons-material/Image";
import ModalForImage from "./ModalImage";
import { useState } from "react";
import { CalUnitPrice } from "../../utils/CalUnitPrice";
const TableProductSale = ({
  product,
  activeTab,
  discount,
  aditional_discount,
}) => {
  console.log(product, "producto");
  console.log(aditional_discount, "aditional_discount");
  console.log(discount, "descuento");

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  console.log(product);

  return (
    <>
      <TableRow>
        <TableCell align='center'>
          <Stack direction='row' spacing={2}>
            <Button
              variant='contained'
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#EA90BD",
                color: "white",
                "&:hover": { backgroundColor: "#EA90BD", color: "white" },
              }}
              endIcon={<ImageIcon />}
            >
              Ver
            </Button>
          </Stack>
        </TableCell>
        <TableCell align='center'>{product?.product?.barcode}</TableCell>{" "}
        {/* Codigo de barras */}
        <TableCell align='center'>{product?.product?.name}</TableCell>{" "}
        {/* Nombre del producto */}
        <TableCell align='center'>
          <>
            {product.product.price_with_discount === null ? (
              <Typography>
                {" "}
                {FormatCurrency(product.product.retail_price ?? 0)}{" "}
                {/* Precio unitario */}
              </Typography>
            ) : (
              <>
                <Typography sx={{ textDecoration: "line-through" }}>
                  {" "}
                  {FormatCurrency(product.product.retail_price ?? 0)}{" "}
                  {/* Precio unitario */}
                </Typography>
                <Typography color='red'>
                  {" "}
                  {FormatCurrency(
                    product.product.price_with_discount ?? 0
                  )}{" "}
                  {/* Precio unitario */}
                </Typography>
              </>
            )}
          </>
        </TableCell>
        {/* Precio unitario */}
        {/* Cantidad */}
        <TableCell align='center'>
          <Typography fontWeight='bold'>{product?.quantity} </Typography>{" "}
        </TableCell>
        {/**Subtotal */}
        <TableCell align='center'>
          <Typography>
            {FormatCurrency(
              product?.product.retail_price * product.quantity ?? 0
            )}{" "}
            {/* Subtotal */}
          </Typography>
        </TableCell>
        {/** Precio con descuento */}
        <TableCell align='center'>
          <Typography
            sx={{
              fontWeight: discount?.discount > 0 ? "bold" : "normal",
              fontSize: 14,
            }}
          >
            {product?.product?.price_with_discount !== null
              ? FormatCurrency(
                  Number(product.product.price_with_discount) *
                    Number(product.quantity ?? 1)
                )
              : aditional_discount > 0
              ? FormatCurrency(
                  Number(product.final_price ?? 0) *
                    (1 - Number(aditional_discount) / 100)
                )
              : FormatCurrency(Number(product.final_price ?? 0))}
          </Typography>
        </TableCell>
        {/** Total */}
        <TableCell align='center'>
          <Typography
            sx={{
              fontWeight: discount?.discount > 0 ? "bold" : "normal",
              fontSize: 14,
            }}
          >
            {product?.product?.price_with_discount !== null
              ? FormatCurrency(
                  Number(product.product.price_with_discount) *
                    Number(product.quantity ?? 1)
                )
              : aditional_discount > 0
              ? FormatCurrency(
                  Number(product.final_price ?? 0) *
                    (1 - Number(aditional_discount) / 100)
                )
              : FormatCurrency(Number(product.final_price ?? 0))}
          </Typography>
        </TableCell>
      </TableRow>
      <ModalForImage
        open={open}
        handleClose={handleClose}
        image={product?.product?.image}
      />
    </>
  );
};
TableProductSale.propTypes = {
  product: PropTypes.object.isRequired,
};
export default TableProductSale;
